import Ticket from "callable-data-objects/dist/models/ticket/Ticket";
import Page from "callable-data-objects/dist/services/Page";
import useCheckRole from "Hooks/APICheckRole";
import React from "react";
import { Button, Container, Table } from "semantic-ui-react";
import TicketStatusLabel from "./TicketStatusLabel";
import TicketTypeLabel from "./TicketTypeLabel";

type TicketListProps = {
  tickets: Page<Ticket>;
  select: Function;
};

const TicketList = ({ tickets, select }: TicketListProps) => {
  const { hasRole, roles } = useCheckRole();
  const canView = hasRole(roles.ticket.roles.select);
  const admin = hasRole(roles.admin);
  const { content } = tickets;
  return (
    <Container fluid style={{ padding: "20px" }}>
      {renderTable(content, select, canView, admin)}
    </Container>
  );
};

const getAccountName = (ticket: Ticket) => {
  if (ticket.type === "port-request") {
    return ticket.portRequest.customer.name;
  } else if (ticket.type === "export-request") {
    return ticket.exportRequest.customer.name;
  } else if (ticket.type === "allocation-request") {
    return ticket.allocationRequest.customer.name;
  } else if (ticket.type === "assignment-request") {
    return ticket.assignmentRequest.customer.name;
  } else if (ticket.type === "migration-request") {
    return ticket.migrationRequest.customer.name;
  }
  return "Unknown";
};

const renderTable = (
  content: Ticket[],
  select: Function,
  canView: Boolean,
  admin: Boolean
) => {
  return (
    <Table celled padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={3} singleLine>
            ID
          </Table.HeaderCell>
          <Table.HeaderCell width={4} singleLine>
            Customer
          </Table.HeaderCell>
          <Table.HeaderCell width={3} singleLine>
            Type
          </Table.HeaderCell>
          <Table.HeaderCell width={3} singleLine>
            Recipient(s)
          </Table.HeaderCell>
          <Table.HeaderCell width={2} singleLine>
            Status
          </Table.HeaderCell>
          {canView && <Table.HeaderCell width={1}>Actions</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {content &&
          content.map((ticket: Ticket) => (
            <Table.Row key={`tr-ddi-${ticket.id}`}>
              <Table.Cell singleLine>{ticket.caseId}</Table.Cell>
              <Table.Cell singleLine>{getAccountName(ticket)}</Table.Cell>
              <Table.Cell singleLine>
                <TicketTypeLabel ticket={ticket} />
              </Table.Cell>
              <Table.Cell singleLine>
                {ticket.emailRecipients.join("\n")}
              </Table.Cell>
              <Table.Cell>
                <TicketStatusLabel ticket={ticket} />
              </Table.Cell>
              {canView && (
                <Table.Cell textAlign='left'>
                  <Button primary size='tiny' onClick={() => select(ticket.id)}>
                    Select
                  </Button>
                </Table.Cell>
              )}
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
};

export default TicketList;
